var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.query.output !== 'embed')?_c('Header'):_vm._e(),_c('TribeNav'),_c('TechRadar',{key:_vm.$route.params.selectedTribe,attrs:{"tribeName":_vm.$route.params.selectedTribe}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }